



























































































































































































































































































import {Component, Emit, Prop} from 'vue-property-decorator';
import Form, {Send, TranslateErrorsOptions} from '@/components/form-base';
import { mixins } from 'vue-class-component';
import ErrorAggregator from '@/components/errors/error-aggregator.vue';

import availableTokens from './config/availableTokens'
import tutorial from '@/components/tutorial/tutorial';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'

import CurrencyMixin from '@/components/helpers/currency-mixin';

import dialogTargetMock from '@/components/dialogs/dialog-target-mock';
import ReportMixin from '@/views/reports/mixins/report-mixin';
import WorkspaceSelect from '@/views/reports/pickers/wokrspace-select.vue';
import NoTagFound from '@/views/reports/views/no-tag-found.vue';
import ApiServices from '@/services';
import TutorialMixin from '@/components/tutorial/tutorial-mixin';
import DomainsApi from '@/services/rest/bemob/domains';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';
import OfferApi from '@/services/rest/bemob/offer';
import AffiliateApi from '@/services/rest/bemob/affiliate-network';
import TagApi from '@/services/rest/bemob/tag';

const md5 = require('md5');

@Component({
  components: {
    ErrorAggregator,
    HeaderButtons,
    WorkspaceSelect,
    NoTagFound
  }
})
export default class CreateOfferDialog extends mixins<PlanLimitsMixin,Form, CurrencyMixin, ReportMixin, TutorialMixin>(PlanLimitsMixin, Form, CurrencyMixin, ReportMixin, TutorialMixin) {
  @Prop({ default: {} })
  data: any;

  show: boolean = false;
  loading: boolean = false;
  domainsApi: DomainsApi = new DomainsApi();
  tagApi: TagApi = new TagApi();
  //chips: any = macroses();
  defaultChips: string[] = availableTokens();
  lastAffiliateNetworkId: string = '';
  form: any = this.defaultForm();
  offer_id: string = '';
  templateData: any = {
    clickIdPlaceholder: 'REPLACE',
    payoutPlaceholder: 'OPTIONAL',
    transactionIdPlaceholder: 'OPTIONAL',
    statusPlaceholder: 'OPTIONAL'
  };

  offerApi: OfferApi = new OfferApi();
  affiliateApi: AffiliateApi = new AffiliateApi();
  affiliateNetworkData=[]
  offerOptions: Offer[] = []

  disableWorkspaceSelect: boolean = false;

  errors: any[] = [];
  errorsControlActive: boolean = false;
  clickIdParam: boolean = false;
  clickIdLong: boolean = false;
  emptyUrlSend: boolean = false;

  dialogTargetMock = dialogTargetMock();

  offersLoaded: boolean = false;

  get modalTitle(){
    return this.t('Create Offer')
  }
  
  get introStepsDefault() {
    return {
      2: `<div class='introjs-tooltip__title'>${this.t('Offer Settings')}</div><div class='introjs-tooltip__content'>${this.t('Specify name of offer')}</div>`,
      3: `<div class='introjs-tooltip__title'>${this.t('Offer Settings')}</div><div class='introjs-tooltip__content'>${this.t('Enter the URL of offer element')}</div>`,
      4: `<div class='introjs-tooltip__title'>${this.t('Offer Settings')}</div><div class='introjs-tooltip__content'>${this.t('Create offer element')}</div>`
    };
  }
  
  get offerOptionsWithoutEdited() {
    if(this.edit){
      return this.offerOptions.filter(item=>item.id!==this.offer_id)
    }
    return this.offerOptions
  }

  get isActionsDisabled() {
    return !!(this.edit && this.aclReadOnly({
      workspaceId: this.form.workspaceId,
      id: this.offer_id,
      type: 'offers',
    }));
  }

  get quickStartSection() {
    return 'offers';
  }

  get enableDailyCap() {
    return this.form.enableDailyCap;
  }

  set enableDailyCap(value: boolean) {
    if(!this.offersLoaded && value) {
      this.$nextTick(() => {
        this.form.enableDailyCap = false;
        this.$store.commit('loading', true);

        this.loadDailyCapOffers()
          .then(() => {
             this.form.enableDailyCap = true;
             this.offersLoaded = true;
          })
          .finally(() => {
            this.$store.commit('loading', false);
          });
      })
    } else {
      this.form.enableDailyCap = value;
    }
  }

  oldHash: string = '';
  getCurrentHash() {
    return md5(JSON.stringify(this.form));
  }
  
  get chips() {
    let tidChip = this.form.affiliateNetworkId;
    let chips = this.defaultChips;
    if(this.clickIdLong) {
      chips = chips.concat(['+ tid={clickIdLong}' ]);
    }

    return chips.map((e: any) => {
      return {
        tag: e,
        disabled: false
      }
    });
  }

  get nameDescriptionCountryName() {
    return this.countryName || this.t('Global');
  }

  get nameDescriptionName() {
    return this.form.name || this.t('None');
  }

  get nameDescription() {
    return `${this.nameDescriptionCountryName} - ${this.nameDescriptionName}`;
  }

  get translateErrorsConfig(): TranslateErrorsOptions {
    let translate: any = {};

    if(this.emptyUrlSend) {
      translate['url'] = {
        VALIDATION_INVALID_URL: 'CUSTOM_VALIDATION_EMPTY_URL'
      }
    }

    return { translate };
  }

  get tutorial() {
    return tutorial(this);
  }

  get postbackUrlParams() {
    return [
        `cid=${this.templateData.clickIdPlaceholder || 'REPLACE'}`,
        `payout=${this.templateData.payoutPlaceholder || 'OPTIONAL'}`,
        `txid=${this.templateData.transactionIdPlaceholder || 'OPTIONAL'}`,
        `status=${this.templateData.statusPlaceholder || 'OPTIONAL'}`
    ];
  }

  get postbackUrlProtocol() {
    return this.$store.getters.cache.trackingDomainsObject[this.$store.state.user.trackingDomainId].httpsAvailable ? 'https' : 'http';
  }

  get postbackUrl() {
    return `${this.postbackUrlProtocol}://${this.$store.getters.cache.trackingDomainsObject[this.$store.state.user.trackingDomainId].domain}/postback?${this.postbackUrlParams.join('&')}`;
  }

  get defaultTemplateData() {
    return {
      clickIdPlaceholder: 'REPLACE',
      payoutPlaceholder: 'OPTIONAL',
      transactionIdPlaceholder: 'OPTIONAL',
      statusPlaceholder: 'OPTIONAL'
    };
  }
  
  get fetchOfferOptions(){
    const { countryId } = this.form;
    if(this.$store.state.cache.offers.isAllInCache){
      return
    }
    return ({ search })=>this.offerApi.getList({
      search:search,
      status:'active',
      limit:'200',
      orderBy:'updated',
      ...(countryId&& { countryId }),
      orderDirection:'desc',
      columns:[ 'id', 'name' , 'countryId', 'affiliateNetworkId' ,'affiliateNetworkName', 'countryName', 'url'],
      workspaceId:this.form.workspaceId
    }).then((data)=>{
      if(this.edit){
        return data.filter(item=>item.id!==this.offer_id)
      }
      return data
    })
  }

  getChangeAffiliatesPromise() {
    return new Promise((resovle, reject) => {
      if (this.lastAffiliateNetworkId && this.form.affiliateNetworkId === this.lastAffiliateNetworkId) {
        resovle();
        return;
      }

      this.lastAffiliateNetworkId = this.form.affiliateNetworkId;

      const setDefault = () => {
        this.templateData = this.defaultTemplateData;
        this.clickIdParam = false;
      };

      if(this.form.affiliateNetworkId) {
        this.affiliateApi.get(this.form.affiliateNetworkId)
          .then((data) => {
            this.affiliateNetworkData = data;
            if (data.templateId && data.affiliateNetworkTemplate) {
              this.templateData = data.affiliateNetworkTemplate;
            } else {
              this.templateData = this.defaultTemplateData;
            }

            this.clickIdParam = data.appendClickId
              ? data.clickIdParam
              : false;

            
            this.clickIdLong = this.templateData.integrationType === 'clickbank';

            resovle();
          })
          .catch(() => {
            reject();
            setDefault();
          });
      } else {
        setDefault();
        resovle();
      }
    })
  }

  async changeAffiliates() {
    await this.getChangeAffiliatesPromise();
  }

  saveCountSumm(summ: number) {
    this.form.dailyCapLimit = summ;
  }

  saveCurrencySumm(summ: number) {
    this.form.payoutSum = summ;
  }

  async loadDailyCapOffers() {
    if(!this.$store.state.cache.offers.isUploaded){
      await this.offerApi.populateStoreCache()
    }
    this.setOfferOptions()
  }

  defaultForm() {
    return {
      name: '',
      currencyId: this.$store.state.user.currencyId,
      countryId: 0,
      payoutType: 'auto',
      affiliateNetworkId: '',
      dailyCapFailoverOffer: {
        id:'',
        name:'',
      },
      payoutSum: 0,
      enableDailyCap: 0,
      dailyCapLimit: 0,
      dailyCapTimezone: this.$store.state.user.defaultTimezone,
      status: 'active',
      url: '',
    }
  }

  subscribeEventBus(){
    this.$on('error', (e: any, payload: any) => {
      this.$store.commit('loading', false);

      this.errors = this.translateErrors(this.parseErrors(e.data.errors), e.data.message, this.translateErrorsConfig);
      this.errorsControlActive = true;
    });
  }

  loadData() {
    this.$store.commit('loading', true);

    const {workspaceId} = this.data;
    this.offersLoaded = false;

    this.load(workspaceId)
      .then(() => {
        if(workspaceId){
          this.form.workspaceId = workspaceId
          this.disableWorkspaceSelect = true;
        }

        this.tutorial.form();
        return this.getChangeAffiliatesPromise();
      })
      .then(() => {
        this.show = true;
      })
      .finally(() => {
        this.$store.commit('loading', false);
        this.oldHash = this.getCurrentHash();
      });
  }

  async mounted() {
    if(!this.$store.state.cache.trackingDomains.isUploaded){
      await this.domainsApi.trackingDomainsPopulateStoreCache()
    }

    if(!this.$store.state.cache.tags.offers.isUploaded){
      await this.tagApi.populateStoreCache({type:'offers'})
    }

    if(!this.$store.state.cache.affiliateNetworks.isUploaded){
      await this.affiliateApi.populateStoreCache()
    }
    
    this.subscribeEventBus();
    this.loadData()
  }

  checkClose() {
    if (this.oldHash !== this.getCurrentHash() && !this.isActionsDisabled) {
      this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: { onConfirm: () => this.close() }})
    } else {
      this.close();
    }
  }

  close() {
    this.$emit('close');
  }

  get countryListPlusGlobal() {
    return this.$store.getters.countryListPlusGlobal;
  }

  get countryName(){
    const country = this.form.countryId && this.countryListPlusGlobal.find((e:any)=> e.id === this.form.countryId);
    return country
      ? country.name
      : '';
  }

  get timezoneList() {
    return this.$store.state.timezoneList;
  }

  processForm(form: any) {
    const preparedForm = {
      ...form,
      dailyCapFailoverOfferId:form.dailyCapFailoverOffer?.id || ''
    }
    delete preparedForm.dailyCapFailoverOffer

    preparedForm.tags = preparedForm?.tags?.map((item)=>item?.id ? item.name : item);
    return preparedForm;
  }

  @Send()
  submit() {
    this.$store.commit('loading', true);

    this.emptyUrlSend = !this.form.url;
    
    return this.offerApi.postCreate(this.processForm(this.form)).then(async (res) => {
      await ApiServices.getUserProfile();
      this.oldHash = this.getCurrentHash();

      this.bus.emit('refresh-report');
      this.bus.emit('toast-success', this.t('Offer has been saved'));

      const {enableDailyCap,name,dailyCapLimit} = this.form;
      this.$mixpanel?.track('offer_create', {
        name,
        ...(enableDailyCap && {'daily_cap_limit': dailyCapLimit}),
      });
      this.close();
      this.data?.onClose?.(res)
    })
    .finally(() => {
      this.$store.commit('loading', false);
    });
  }

  get affiliatesList() {
    const allWorkspaces = [...new Set([this.form.workspaceId,...this.$store.getters.allPublicWorkspacesIds])]
    let nullElem: any = [
      {
        name: this.t('None'),
        id: ''
      }
    ];
    const filteredAffiliateNetworks = this.$store.state.cache.affiliateNetworks.data.filter((affiliateNetwork)=>{
      return allWorkspaces.includes(affiliateNetwork.workspaceId)
    })
    return nullElem.concat(filteredAffiliateNetworks);
  }
  
  onChangeWorkspace(value: any) { 
      const { affiliateNetworkId,dailyCapFailoverOffer} = this.defaultForm();
      this.clickIdParam = false

      this.form = {
        ...this.form,
        affiliateNetworkId,
        dailyCapFailoverOffer,
      };
      this.setOfferOptions()
  }

  get showPlanLimitsWarning_tags() {
    return this.form.tags?.length && this.hasPlanLimitsRestriction('tagsOffers')
  }

  clearTags(){
    this.form.tags = []
  }

  setOfferOptions() {
    const {uploadedForWorkspace, uploadedForCountryId, isAllInCache, data, isUploaded} = this.$store.state.cache.offers;
    if(isUploaded && isAllInCache) {
      return this.offerOptions = data.filter(item => (this.$store.getters.allPublicWorkspacesIds.includes(item.workspaceId) || item.workspaceId === this.form.workspaceId))
    }

    if(isUploaded && !isAllInCache && uploadedForWorkspace === this.form.workspaceId){
      return this.offerOptions = [...data]
    }

    if(this.form.workspaceId === this.defaultWorkspace.id){
      return this.offerApi.updateStoreCache({
        workspaceId: this.defaultWorkspace.id,
        countryId: 0
      }).then((res:Offer[])=>{
        this.offerOptions = res
      })
    }
    return this.offerApi.getList({
      status:'active',
      limit:'200',
      orderBy:'updated',
      orderDirection:'desc',
      columns:[ 'id', 'name' , 'countryId', 'workspaceId',  'affiliateNetworkId' ,'affiliateNetworkName', 'countryName', 'url'],
      workspaceId:this.form.workspaceId,
    }).then((res:Offer[])=>{
      this.offerOptions = res
    })
  }
}
